/* eslint-disable react/prop-types */
// Fuel.jsx
import React from 'react'
import High from './High'
import Low from './Low'

const FuelDefault = function FuelDefault ({ high, low, style = { fill: '#284047' } }) {
  return (
    <Fuel high={high} low={low} style={style} />
  )
}

export default FuelDefault

const Fuel = function Fuel ({ high, low, style }) {
  const {
    fill,
  } = style

  return (
    <svg viewBox='0 0 75 75'>
      <g transform='translate(4,12) scale(1.1)'>
        <path fill={fill} d='M30.239 36.933c-.347-.139-.763-.208-1.18-.208h-.415c-.278 0-.486.07-.763.139L13.313 17.163c-.347-.486-.971-.555-1.457-.208-.485.347-.555.971-.208 1.457l14.637 19.77c-.486.693-.763 1.526-.624 2.428.208 1.803 1.734 3.121 3.468 3.052.555 0 1.04-.139 1.526-.347 1.18-.555 1.943-1.734 1.943-3.122 0-1.526-.972-2.774-2.359-3.26zm-2.29 2.428c.209-.277.556-.486.903-.486h.138c.694 0 1.318.555 1.388 1.249.07.763-.486 1.457-1.249 1.526h-.139c-.693 0-1.318-.555-1.387-1.248 0-.417.139-.764.347-1.041z' />
        <path fill={fill} d='M56.738 12.446C49.385 5.093 39.534 1 29.06 1h-.347c-10.336.07-20.048 4.162-27.4 11.446-.417.416-.417 1.04 0 1.457l7.352 7.422c.416.416 1.04.416 1.457 0 .416-.416.902-.832 1.387-1.249l-1.179-1.734c-.277.278-.555.486-.832.763L3.6 13.21C10.4 6.758 19.28 3.15 28.713 3.08h.347c6.59 0 12.972 1.734 18.59 4.995l-4.162 7.214c-4.37-2.567-9.295-3.885-14.428-3.885h-.278c-5.41.07-10.613 1.596-15.122 4.44l1.248 1.665c4.163-2.567 8.949-4.024 13.874-4.093h.278c7.145 0 13.804 2.775 18.868 7.839.416.416 1.04.416 1.457 0l7.353-7.353c.416-.347.416-1.04 0-1.457zm-5.203-.833h-2.15v1.18h1.873v1.11h-1.873v2.08h-1.318v-5.41h3.468v1.04z' />
        <path fill={fill} d='M8.25 10.434h3.398v1.11h-2.15v1.04H11.3v1.11H9.498v1.18h2.22v1.11H8.18v-5.55h.07z' />
      </g>
      {!!high && (
        <g id='high' transform='translate(40,40) scale(.4)'>
          <High />
        </g>
      )}

      {!!low && (
        <g id='low' transform='translate(40,40) scale(.4)'>
          <Low />
        </g>
      )}
    </svg>
  )
}
